module.exports = __webpack_public_path__ + "img/positiveEffects@2x.b48f1df.jpg";